import React from 'react';

import braintree from 'braintree-web';

import { getCsrfToken } from '../helpers/GetCsrfToken';
import DeviceId from '../flows/DeviceId';
import { logClientEvent } from '../helpers/ClientLog';

export default class extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      canMakePaymentsWithActiveCard: false,
      finishedLoadingApplePay: false
    };
  }

  componentDidMount() {
    const ApplePaySession = window.ApplePaySession;
    if (
      !!window.ApplePaySession &&
      ApplePaySession.supportsVersion(3) &&
      ApplePaySession.canMakePayments()
    ) {
      // This device supports version 3 of Apple Pay.
    }
    if (!ApplePaySession) {
      console.error('This device does not support Apple Pay');
    }

    if (!ApplePaySession.canMakePayments()) {
      console.error('This device is not capable of making Apple Pay payments');
    }

    braintree.client
      .create({
        authorization: this.props.clientToken
      })
      .then(clientInstance => {
        return braintree.applePay.create({
          client: clientInstance
        });
      })
      .then(applePayInstance => {
        // Alternatively, check if the device has an Apple Pay card available.
        // You can do this if your checkout flow defaults to Apple Pay
        // or if you are displaying Apple Pay buttons on a product detail page.

        // Use your Apple Pay merchant identifier
        // to check if payments can be made.
        return ApplePaySession.canMakePaymentsWithActiveCard(
          applePayInstance.merchantIdentifier
        ).then(canMakePaymentsWithActiveCard => {
          // Set up Apple Pay buttons
          this.setState({
            canMakePaymentsWithActiveCard: true,
            finishedLoadingApplePay: true
          });
          var paymentRequest = applePayInstance.createPaymentRequest({
            total: {
              label: 'Pizza Express',
              amount: this.props.grandTotal
            },
            requiredShippingContactFields: ['email'],

            // We recommend collecting billing address information, at minimum
            // billing postal code, and passing that billing postal code with
            // all Apple Pay transactions as a best practice.
            requiredBillingContactFields: ['postalAddress']
          });      

          this.paymentRequest = paymentRequest;

          const button = document.getElementById('apple-pay-button');

          button.addEventListener('click', event => {
            event.preventDefault();
            logClientEvent('Pay button clicked', { PaymentMethod: 'ApplePay' });
            var session = new ApplePaySession(3, paymentRequest);

            session.onvalidatemerchant = event => {
              applePayInstance
                .performValidation({
                  validationURL: event.validationURL,
                  displayName: 'Pay at Table'
                })
                .then(merchantSession => {
                  session.completeMerchantValidation(merchantSession);
                })
                .catch(validationErr => {
                  // You should show an error to the user, e.g. 'Apple Pay failed to load.'
                  console.error('Error validating merchant:', validationErr);
                  session.abort();
                });
            };
            let email = "";
            session.onpaymentauthorized = event => {
              this.props.submitPayment();
              logClientEvent('Payment submitted', { PaymentMethod: 'ApplePay' });
              email = event.payment.shippingContact.emailAddress;
              applePayInstance
                .tokenize({
                  token: event.payment.token
                })
                .then(payload => {
                  fetch('api/Braintree/Pay', {
                    method: 'post',
                    headers: {
                      Accept: 'application/json',
                      'Content-Type': 'application/json',
                      'X-XSRF-TOKEN': getCsrfToken(),
                      'DEVICE_ID': DeviceId.DEVICE_ID
                    },
                    body: this.props.generatePaymentBody(payload, email)
                  })
                    .then(response => response.json())
                    .then(data => {
                      if (data.success === true) {
                        this.props.storeCustomerEmail(email);
                        this.props.paymentSuccessful(data);
                      } else {
                        this.props.submitPaymentFail();
                      }
                    })
                    .catch(err => {
                      console.log(err);
                      this.props.submitPaymentFail();
                    });

                  // After you have transacted with the payload.nonce,
                  // call `completePayment` to dismiss the Apple Pay sheet.
                  session.completePayment(ApplePaySession.STATUS_SUCCESS);
                })
                .catch(tokenizeErr => {
                  console.error('Error tokenizing Apple Pay:', tokenizeErr);
                  session.completePayment(ApplePaySession.STATUS_FAILURE);
                });
            };

            session.begin();
          });
        });
      })
      .catch(err => {
        this.setState({
          canMakePaymentsWithActiveCard: false,
          finishedLoadingApplePay: true
        });
        // Handle error
      });
  }

  render() {
    return (
      <div
        style={
          this.props.submittingPayment === true ? { display: 'none' } : {}
        }
        className="payment-type"
      >
        <div
          style={
            this.state.finishedLoadingApplePay === false ||
            this.state.canMakePaymentsWithActiveCard === false
              ? { visibility: 'hidden' }
              : { margin: 0, display: 'block' }
          }
          id="apple-pay-button"
          className="apple-pay-button apple-pay-button-black"
        ></div>
        {this.state.finishedLoadingApplePay === true &&
          this.state.canMakePaymentsWithActiveCard === false && (
            <div>
              <p>
                Your browser or device does not support Apple Pay on the web.
              </p>
            </div>
          )}
      </div>
    );
  }
}
